import React from "react";
import ReactSelect, { Props } from "react-select";
import { FieldProps } from "formik";
import cx from "clsx";

export interface SelectProps extends FieldProps, Props {
  label?: string;
  afterChange?(option: any): void;
}

export default ({ label, field, form, afterChange = () => {}, ...rest }: SelectProps) => {
  const touched = form.touched[field.name];
  const error = form.errors[field.name];

  const labelClasses = cx("control-label", { "text-danger": touched && error });

  const feedbackClasses = cx({
    "invalid-feedback": touched && error,
    "valid-feedback": touched && !error
  });

  return (
    <div className="form-group">
      {label && <label className={labelClasses}>{label}</label>}
      <ReactSelect
        {...rest}
        value={field.value}
        onChange={option => {
          form.setFieldValue(field.name, option);
          afterChange(option);
        }}
        onBlur={() => form.setFieldTouched(field.name, true)}
      />
      {touched && error && <div className={feedbackClasses}>{error}</div>}
    </div>
  );
};
